import { format } from "date-fns";
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface BlogPost {
  id: string;
  title: string;
  description: string;
  date: string;
  image_url: string;
  category: string;
  slug: string;
}

interface BlogCardProps {
  post: BlogPost;
}

export const BlogCard = ({ post }: BlogCardProps) => {
  return (
    <Link to={`/blog/${post.slug}`}>
      <Card className="overflow-hidden hover:shadow-lg transition-shadow h-full">
        <div className="aspect-video relative overflow-hidden">
          <img 
            src={post.image_url || 'https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?q=80&w=800'} 
            alt={post.title}
            className="object-cover w-full h-full hover:scale-105 transition-transform duration-300"
          />
        </div>
        <CardHeader>
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm text-muted-foreground">
              {format(new Date(post.date), 'MMMM d, yyyy')}
            </span>
            <span className="text-sm font-medium text-primary">{post.category}</span>
          </div>
          <CardTitle className="line-clamp-2">{post.title}</CardTitle>
          <CardDescription className="line-clamp-3">
            {post.description}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <span className="text-primary hover:text-primary/80 font-medium">
            Read More →
          </span>
        </CardContent>
      </Card>
    </Link>
  );
};